import { apiClient } from '~/api/client';
import { LoanTransactionsMeta } from '~/sections/loan-officers/profile/financial-performance/types';

type IndexParams = {
  period: string;
  only_transactions: boolean;
  nmls: string;
};

type IndexResponse = {
  meta: LoanTransactionsMeta;
};

export const index = async (allParams: IndexParams) => {
  const { nmls, ...params } = allParams;
  return apiClient.get<IndexResponse>(`/loan_officers/${nmls}/dashboard`, { params });
};
